// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2Enot","boxTitle":"Qualiphy_boxTitle__9cNHV","box":"Qualiphy_box__1e9Nq","toggleWrap":"Qualiphy_toggleWrap__1gqVH"};